import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Approuter from './approuter';
import Login from './components/pages/login';
import ChangePassword from './components/pages/login/ChangePassword';
import LockScreen from './components/pages/login/LockScreen';
import { useSelectedUser } from './components/staff/SelectedUserProvider';

const App = () => {

    const { loginUser, loginBranch, assignedBranches } = useSelectedUser();

    console.log('[App] loginUser:', loginUser !== null, 'loginBranch:', loginBranch?.branchId ?? null,
        'branches:', Array.isArray(assignedBranches) ? assignedBranches.length : 'null');

    if (loginUser === null) {
        return <Login />;
    }

    const branches = Array.isArray(assignedBranches) ? assignedBranches : [];
    const manualBranch = sessionStorage.getItem('hmsv2-branch-manual') === '1';
    const hasBranch = loginBranch !== null;
    const multiBranch = branches.length > 1;

    // Force branch selection for multi-branch users unless the branch was explicitly
    // chosen via the in-app branch switcher (which reloads the page afterwards).
    const needsLockScreen = !hasBranch || (multiBranch && !manualBranch);

    if (!needsLockScreen) {
        return <Approuter />;
    }

    return loginUser.userStatus === 'NEW' ? <ChangePassword /> : <LockScreen />;
}

export default App;